import { render, staticRenderFns } from "./StreamingChartModule.vue?vue&type=template&id=5673887f&scoped=true"
import script from "./StreamingChartModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./StreamingChartModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StreamingChartModule.vue?vue&type=style&index=0&id=5673887f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5673887f",
  null
  
)

export default component.exports